"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsForceBillingAddressSchema = void 0;
const joi_1 = __importDefault(require("joi"));
const constants_1 = require("../../constants");
/**
 * This is only a slice of SF data. If you need more, add more
 */
exports.JsForceBillingAddressSchema = joi_1.default.object({
    Id: joi_1.default.string().required(),
    Name: joi_1.default.string().required(),
    Account__c: joi_1.default.string().required(),
    Account_number__c: joi_1.default.string().allow(null),
    City__c: joi_1.default.string().allow(null),
    Company_name__c: joi_1.default.string().allow(null),
    Country__c: joi_1.default.string().allow(null),
    Country_code__c: joi_1.default.string().allow(null),
    CurrencyIsoCode: joi_1.default.string().allow(null),
    Invoice_recipient__c: joi_1.default.string().allow(null),
    Invoice_recipient_email__c: joi_1.default.string()
        .email({ tlds: { allow: !constants_1.isBrowser } })
        .allow(null),
    Postal_code__c: joi_1.default.string().allow(null),
    State__c: joi_1.default.string().allow(null),
    State_code__c: joi_1.default.string().allow(null),
    Street__c: joi_1.default.string().allow(null),
    UUID__c: joi_1.default.string().uuid().allow(null),
    VAT_number__c: joi_1.default.string().allow(null),
    VAT_validated__c: joi_1.default.boolean().required()
})
    .unknown(true)
    .meta({ className: 'JsForceBillingAddress' });
//# sourceMappingURL=JsForceBillingAddressSchema.js.map